<template>
  <v-dialog
    v-if="requestDialog"
    v-model="requestDialog"
    width="590"
    persistent
  >
    <v-card>
      <v-card-title
        class="header info"
        primary-title
      >
        <b>{{ $t('investors.completeReq') }}</b>
      </v-card-title>
      <v-card-text class="data mt-5">
        {{ $t('investors.reqText1') }}
        <b>"{{ currentConnection.project.name }}"</b> 
        {{ $t('investors.reqText2') }}
        <v-layout
          wrap
          mt-5
        >
          <v-flex
            md4
            sm4
            xs4
          > 
            <span>{{ $t('globals.aum2') }}</span>
            <p class="text-primary balance">
              {{ currentConnection.investor.base_currency | renderSymbol }} 
              {{ currentConnection.investor.account_balance }}
            </p>
            <span>{{ $t('globals.managementFee') }}</span>
            <p>{{ currentConnection.management_fee }}%</p>
          </v-flex>
          <v-flex
            md4
            sm4
            xs4
            pl-5
          > 
            <span>{{ $t('globals.insurance') }}</span>
            <p>{{ currentConnection.insurance }}%</p>              
            <span>{{ $t('globals.affFee') }}</span>
            <p>{{ currentConnection.referral_fee }}%</p>
          </v-flex>
          <v-flex
            md4
            sm4
            xs4
          > 
            <span>{{ $t('globals.allowedDrawdown') }}</span>
            <p>{{ currentConnection.drawdown }}%</p>
            <span>{{ $t('globals.platformFee') }}</span>
            <p>{{ currentConnection.platform_fee }}%</p>
          </v-flex>
        </v-layout>
        <div
          v-if="currentConnection.insurance > 0"
        >
          {{ $t('investors.note2') }}
          <v-text-field
            v-model="securityWallet"
            style="margin-top:30px;"
            name="wallet"
            :label="$t('investors.securityWallet')"
            readonly
            @focus="$event.target.select()"
          >
            <template v-slot:append>
              <v-icon
                v-clipboard:copy="securityWallet"
                style="cursor:pointer;"
              >
                mdi-content-copy
              </v-icon>
            </template>
          </v-text-field>
          <v-text-field
            name="wallet"
            :label="$t('investors.securityDeposit')"
            :value="currentConnection.required_security_deposit"
            :suffix="currentConnection.investor.base_currency"
            readonly
            @focus="$event.target.select()"
          />
          <v-flex 
            v-if="noDeposit"
            warning
            style="padding:5px;"
          >
            <small><b>{{ $t('investors.notDeposited') }}</b></small>
          </v-flex>   
          <v-flex
            v-else
          >
            <small><b>{{ $t('investors.contactSupport') }}</b></small>
          </v-flex>  
        </div>    
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          text
          :disabled="loading"
          @click="requestDialog = false"
        >
          {{ $t('globals.closeButton') }}
        </v-btn>
        <v-btn
          color="primary"
          :disabled="loading"
          :loading="loading"
          @click="accept()"
        >
          {{ $t('investors.acceptButton') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ACCEPT_INVESTOR_MUTATION from '@/graphql/mutations/AcceptInvestor.gql'

export default {
  name: 'CompleteRequestDialog',
  props: {
    currentConnection: {
      type: Object,
      default() {
        return {}
      }
    },
     showDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      noDeposit: false
    }
  },
  computed: {
    securityWallet: {
      get() {
         return this.currentConnection.investor.base_currency == 'BTC'
          ? '3MLoo8k5JeDhdHYcFUVpuv6Eijzn9v4Jof' 
          : '0x2C793F2f7dDdDB8F893926f7E165e53D67AACc85'
      },
      set() {}
    },
    requestDialog: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$parent.acceptDialog = val
      }
    }
  },
  methods: {
    accept() {
      if (this.currentConnection.required_security_deposit != this.currentConnection.transfered_security_deposit) {
        this.noDeposit = true
        return
      }
      this.loading = true;
      this.$apollo.mutate({
        mutation: ACCEPT_INVESTOR_MUTATION,
        variables: {
          id: this.currentConnection.id
        },
      }).then(data => {
        this.loading = false
        this.responseHandler(data)
        this.$parent.$apollo.queries.projectInvestors.refetch()
        this.requestDialog = false
      }).catch(error => {
        this.errorHandler(error)
        this.loading = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>

.data {
  span {
    font-size: 12px;
    font-weight: 600;
    color: #7f97ab;
    text-transform: uppercase;
  }
  p {
    font-size: 16px;
    font-weight: 700;
    color: #000;
  }
  small {
    font-size:13px;
    line-height: 16px;
    display: inline-block;
  }
} 
</style>
